export class CPRAttribute {
    private static cprReg = new RegExp(/([0-9]{6,8}[\-+A]{0,1})(([0-9]{4,5})|[0-9]{3}[a-yA-Y]{1})/);

    public static hasError(value: string): boolean {
        if (!value || !this.cprReg.test(value)) {
            return true;
        }
        return false;
    }

    public static getErrorMessage(): string {
        return "Indtast et gyldigt CPR-nummer";
    }




    public static isCoAppDuplicate(value: string, oldValue: string): boolean {
        if (value == oldValue) {
            return true;
        }
        return false;
    }

    public static getDuplicateErrorMessage(): string {
        return "CPR-nummer kan ikke være det samme som medansøger's CPR-nummer";
    }
}